import React, { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const ACCENT = '#ff8c42';
const STATUS_COLORS = {
  todo: '#ffd600',
  inprogress: '#ff8c42',
  done: '#f76ea8',
};

function StatCard({ label, value, color }) {
  return (
    <div style={{
      background: '#fff',
      borderRadius: 16,
      padding: '24px 28px',
      flex: 1,
      minWidth: 150,
      boxShadow: '0 2px 12px #0000000d',
      borderTop: `4px solid ${color}`,
    }}>
      <div style={{ fontSize: 36, fontWeight: 800, color }}>{value}</div>
      <div style={{ fontSize: 14, color: '#7f849c', marginTop: 4 }}>{label}</div>
    </div>
  );
}

export default function Dashboard({ onNavigate }) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, 'tasks'),
      (snap) => {
        setTasks(snap.docs.map(d => ({ ...d.data(), id: d.id })));
        setLoading(false);
      },
      () => setLoading(false)
    );
    return unsub;
  }, []);

  const todo = tasks.filter(t => t.status === 'todo').length;
  const inprogress = tasks.filter(t => t.status === 'inprogress').length;
  const done = tasks.filter(t => t.status === 'done').length;

  const recent = [...tasks]
    .sort((a, b) => (b.created?.seconds || 0) - (a.created?.seconds || 0))
    .slice(0, 5);

  return (
    <div>
      {/* Welcome banner */}
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ margin: 0, fontSize: 28, fontWeight: 800, color: '#1e1e2e' }}>
          HX CLOUD
        </h1>
        <p style={{ margin: '6px 0 0 0', color: '#7f849c', fontSize: 15 }}>
          Your cloud-powered task manager. Here's an overview of your work.
        </p>
      </div>

      {/* Stat cards */}
      <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', marginBottom: 32 }}>
        <StatCard label="Total Tasks" value={loading ? '—' : tasks.length} color="#4ade80" />
        <StatCard label="To Do" value={loading ? '—' : todo} color={STATUS_COLORS.todo} />
        <StatCard label="In Progress" value={loading ? '—' : inprogress} color={STATUS_COLORS.inprogress} />
        <StatCard label="Done" value={loading ? '—' : done} color={STATUS_COLORS.done} />
      </div>

      {/* Recent tasks */}
      <div style={{
        background: '#fff',
        borderRadius: 16,
        padding: '24px 28px',
        boxShadow: '0 2px 12px #0000000d',
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
        }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#1e1e2e' }}>
            Recent Tasks
          </h3>
          <button
            onClick={() => onNavigate('tasks')}
            style={{
              background: ACCENT,
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '7px 16px',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            View All →
          </button>
        </div>

        {loading ? (
          <p style={{ color: '#7f849c' }}>Loading tasks…</p>
        ) : recent.length === 0 ? (
          <div style={{ color: '#7f849c', textAlign: 'center', padding: '24px 0' }}>
            No tasks yet.{' '}
            <button
              onClick={() => onNavigate('tasks')}
              style={{
                color: ACCENT,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: 'inherit',
              }}
            >
              Create your first task →
            </button>
          </div>
        ) : (
          recent.map(task => (
            <div
              key={task.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '10px 0',
                borderBottom: '1px solid #f1f1f5',
              }}
            >
              <span style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                background: STATUS_COLORS[task.status] || '#ccc',
                flexShrink: 0,
              }} />
              <span style={{ flex: 1, color: '#1e1e2e', fontSize: 15 }}>{task.content}</span>
              <span style={{
                fontSize: 12,
                color: '#7f849c',
                background: '#f1f1f5',
                borderRadius: 6,
                padding: '2px 10px',
              }}>
                {task.status === 'todo'
                  ? 'To Do'
                  : task.status === 'inprogress'
                  ? 'In Progress'
                  : 'Done'}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
